<template>
  <div>
    <MergeAndFinalizeTab/>
  </div>
</template>
<script>
import MergeAndFinalizeTab from '../../../../components/tax/SpecialTaxItems/newTaxRoll/mergeAndFinalize.vue';

export default {
  name: 'MergeAndFinalize',
  components: {
    MergeAndFinalizeTab,
  },
};
</script>
